import { StyleSheet, Text } from "react-native";

import type { UiTheme } from "../theme";

// <SectionHeader> — THE plain uppercase micro-label that names a region of a
// screen. The census in next/consolidation.md counted this recipe hand-rolled
// in 60+ places (`sectionLabel` in LibraryBrowser, `sectionTitle` in
// catalogStyles / workoutsStyles / ExerciseSwapPicker.styles, …); this is the
// primitive that row asked for, built when DS-42 gave it two fresh callsites
// in one screen rather than as a speculative wave.
//
// ⛔ NOT the boxed list header. A `surface2`-filled, hairline-bordered header
// carrying a COUNT (ExerciseSwapPicker's own `sectionHeader`, the Suggeriti /
// Tutti groups) is a different object: it separates rows inside one list. This
// one names a BAND of the screen and draws no box at all. Keeping them
// visually distinct is the whole point of DS-42 — if the band heading grew a
// fill it would read as another list group.
//
// `ink2`, not the `ink3` LibraryBrowser used: this is a heading, and a heading
// is the last thing that should be the quietest text on screen. The other
// callsites collapse into this one boy-scout, not in this changeset.
export type SectionHeaderProps = {
  theme: UiTheme;
  title: string;
  /** Layout-only override (margins/padding at the callsite). Merged last. */
  style?: React.ComponentProps<typeof Text>["style"];
};

export function SectionHeader({ theme, title, style }: SectionHeaderProps) {
  const styles = makeStyles(theme);
  return (
    <Text
      accessibilityRole="header"
      // RNW drops accessibilityRole on some components: `role` reaches the web.
      role="heading"
      style={[styles.label, style]}
      numberOfLines={2}
    >
      {title}
    </Text>
  );
}

function makeStyles(theme: UiTheme) {
  const { palette: p, typography: t } = theme;
  return StyleSheet.create({
    label: {
      color: p.ink2,
      fontSize: t.sizes.xs,
      fontWeight: "700",
      letterSpacing: 0.6,
      textTransform: "uppercase",
    },
  });
}
